const dictionary_de = {
  select_lang: 'WÄHLEN SIE IHRE SPRACHE',
  lang: 'Deutsch',
  locale: 'de-DE',
  lang_short: 'de',
  dateFormat: 'dd.MM.yyyy',
  datePlaceholder: 'TT.MM.JJJJ',

  technical_error:
    'Es ist ein technischer Fehler aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
  technical_error_hard:
    'Es ist ein technischer Fehler aufgetreten. Bitte wenden Sie sich an den Absender.<p style="color: #bbb; max-height: 200px">%s</p>',

  portal_link: 'https://paperfly.io',
  agb_link: 'https://paperfly.io/agb/',
  contact_link: 'https://paperfly.io/contact-de/',

  address_dialog_personalInfo: 'Persönliche Informationen',
  address_dialog_firstName: 'Vorname',
  address_dialog_lastName: 'Nachname',
  address_dialog_dateOfBirth: 'Geburtsdatum',
  address_dialog_dateOfBirth_err_18:
    'Die Registrierung ist nur für Personen ab 18 Jahren zulässig.',
  address_dialog_contactInformation: 'Kontaktinformationen',
  address_dialog_email: 'E-Mail',
  address_dialog_phone: 'Telefon',
  address_dialog_address: 'Adresse',
  address_dialog_street: 'Straße',
  address_dialog_houseNumber: 'Hausnr.',
  address_dialog_zipcode: 'PLZ',
  address_dialog_city: 'Stadt',
  address_dialog_countryCode: 'Land',

  dialog_atrust_settings_title: 'Qualifizierte Signatur erforderlich',
  dialog_atrust_select_next_options: 'Wählen Sie eine Option, um fortzufahren',
  dialog_atrust_register_done:
    'Die Videoidentifikation ist abgeschlossen, der Signaturprozess wird jetzt gestartet.',
  dialog_atrust_register: 'Elektronische Signatur per Videoidentifikation',
  dialog_atrust_register_help:
    'Erstellen Sie eine qualifizierte elektronische Signatur (QES) über A-Trust und WebID (Videoidentifikation).',
  dialog_atrust_login_exists: 'Bei bestehendem ID Austria-Konto anmelden',
  dialog_atrust_login_exists_help:
    'Sie haben bereits ein ID Austria-Konto? Melden Sie sich mit Ihren bestehenden Zugangsdaten an.',
  dialog_atrust_error_on_registration:
    'Während der Videoidentifikation ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  dialog_atrust_cancelled_on_registration:
    'Videoidentifikation wurde vom Benutzer abgebrochen',
  dialog_atrust_unknown_error_on_registration:
    "Unbekannter Fehler bei der Videoidentifikation '%s'. Videoidentifikation nicht möglich",
  dialog_atrust_awaiting_registration: 'Warte auf Videoidentifikation...',
  dialog_atrust_already_registered:
    'Ein Benutzer mit diesen Daten besitzt bereits ein Konto. Mit bestehendem Konto anmelden?',
  dialog_atrust_login: 'Anmelden',
  dialog_atrust_preparing_title: 'Vorbereitung',
  dialog_atrust_preparing_help:
    'Bitte warten Sie, während wir das Dokument für die Videoidentifikation vorbereiten.',
  dialog_atrust_preparing_help_login:
    'Bitte warten Sie, während wir das Dokument für die Signatur vorbereiten.',
  dialog_atrust_ready_to_sign_help:
    'Drücken Sie START, um die Signatur im A-Trust-Fenster abzuschließen.',
  dialog_atrust_ready_for_webid_help:
    'Drücken Sie «Videoidentifikation starten», um im A-Trust-Fenster fortzufahren.',
  dialog_atrust_awaiting_webid_help:
    'Bitte schließen Sie die Videoidentifikation im A-Trust-Fenster ab.',
  dialog_atrust_awaiting_sign_help:
    'Bitte schließen Sie die Signatur im A-Trust-Fenster ab.',
  dialog_atrust_prep_document:
    'Dokument vorbereiten (Anfrage erstellen / finalisieren)',
  dialog_atrust_prep_check_registration: 'Videoidentifikationsstatus prüfen',
  dialog_atrust_prep_document_error:
    'Dokument konnte nicht vorbereitet werden. Bitte versuchen Sie es erneut.',
  dialog_atrust_start_webid: 'Videoidentifikation starten',
  dialog_atrust_restart_webid: 'Videoidentifikation erneut starten',
  dialog_atrust_status_check_hint:
    'Die Statusprüfung kann etwa 5 Sekunden dauern. Falls das A-Trust-Fenster aus einem anderen Grund geschlossen wurde, starten Sie die Videoidentifikation erneut.',
  dialog_atrust_status_check_help: 'Videoidentifikationsstatus wird geprüft…',
  dialog_atrust_confirm_restart_registration:
    'Prüfung des Videoidentifikationsstatus abbrechen und Videoidentifikation erneut starten?',
  dialog_atrust_confirm_abort_status_check:
    'Prüfung des Videoidentifikationsstatus abbrechen?',
  dialog_atrust_registration_done_sign_hint:
    'Videoidentifikation erfolgreich abgeschlossen. Drücken Sie START, um sich anzumelden und die Signatur abzuschließen.',
  dialog_atrust_short_term_done_sign_hint:
    'Videoidentifikation erfolgreich abgeschlossen. Sie haben 15 Minuten Zeit, um die Signatur im A-Trust-Fenster abzuschließen.',
  dialog_atrust_short_term_expired:
    'Die Zeit für die Signatur ist abgelaufen. Starten Sie die Videoidentifikation erneut.',
  dialog_atrust_document_sign: 'Dokument signieren',
  dialog_atrust_repeat_document_sign: 'Signierung fortsetzen',
  dialog_atrust_sign_status_check_help: 'Signaturstatus wird geprüft…',
  dialog_atrust_sign_status_check_hint:
    'Die Statusprüfung kann etwa 5 Sekunden dauern. Falls das A-Trust-Fenster aus einem anderen Grund geschlossen wurde, tippen Sie auf «Signierung fortsetzen».',
  dialog_atrust_complete_webid: 'Videoidentifikation im %s-Fenster abschließen',
  dialog_atrust_prep_completed_sub: 'Anfrage · Dokument · Videoidentifikation',
  qes_step_create_request: 'Anfrage erstellen',
  qes_step_create_request_hint:
    'Bitte füllen Sie die erforderlichen Daten aus.',
  qes_ready_create_request_help:
    'Drücken Sie WEITER, um die erforderlichen Daten auszufüllen.',
  qes_step_prepare_document: 'Dokument vorbereiten',
  qes_step_check_registration: 'Registrierungsstatus prüfen',
  qes_step_check_signature: 'Signaturstatus prüfen',
  qes_step_prep_completed: 'Vorbereitung abgeschlossen',
  qes_step_prep_completed_sub: 'Anfrage · Dokument · Registrierung',
  qes_step_complete_registration: 'Registrierung im %s-Fenster abschließen',
  qes_step_complete_signing: 'Signatur im %s-Fenster abschließen',
  qes_step_auto_close_hint: 'Schließt automatisch in 3 Sek.',
  qes_registration_readonly_fields_hint:
    'Einige Felder können schreibgeschützt sein, da die Daten zur vollständigen Übereinstimmung direkt aus den Dokumenten übernommen werden. Falls Sie eine fehlerhafte Eingabe bemerken, kehren Sie bitte zum Dokument zurück, um diese zu korrigieren.',

  document_rejected_message: 'Diese dokument wurde abgelehnt.',
  reject_document_title: 'Dokument ablehnen',
  reject_document_info:
    'Sie sind dabei, "%s" abzulehnen. Bitte geben Sie einen Grund an.',
  reject_document_reason: 'Ablehnungsgrund',
  reject_document_reason_placeholder:
    'Beschreiben Sie den Grund für die Ablehnung…',
  reject_document_form_data: 'Formulardaten',
  reject_document_dont_submit_data: 'Formulardaten nicht übertragen',
  reject_document_dont_submit_data_help:
    'Bestehende Formulardaten löschen und nicht übertragen',
  reject_document_submit_data: 'Formulardaten übertragen',
  reject_document_submit_data_help: 'Bestehende Formulardaten übertragen',

  home_password_wrong: 'Falsches Passwort',
  home_password_verification: 'Überprüfung...',
  home_password_required: 'Passwort erforderlich',
  home_request_for_documents: '%s hat von Ihnen folgende Dokumente angefordert',
  home_request_for_payment: '%s hat von Ihnen eine Zahlung angefordert',
  home_will_pay: 'Ich möchte bezahlen',
  home_will_docs: 'Wie möchten Sie fortfahren?',
  home_pay_with: 'mit meinem Computer',
  home_load_with: 'Auf diesem Computer fortfahren',
  home_now_pay: 'Jetzt zahlen',
  home_now_load: 'Dokumente übermitteln',
  home_now_load_one: 'Dokument übermitteln',
  home_now_view: 'Dokumente ansehen',
  home_now_view_one: 'Dokument ansehen',
  home_now_info: 'Lesen',
  list_loaded_pages: 'Hochgeladene seiten',

  home_with_mobile: 'mit meinem Handy',
  home_with_mobile_scan:
    'Scannen Sie den QR Code, um auf Ihr Smartphone zu wechseln',
  home_webrtc_warning:
    'Um die ID-Verifizierung durchführen zu können, müssen Sie den erhaltenen Link in Safari öffnen.',
  home_pincode_required: 'Bitte geben Sie den Sicherheitscode ein.',
  home_pincode_failed: 'Der eingegebene Code ist ungültig.',
  home_request_closed:
    'Diese Dokumentenanfrage ist geschlossen. Bitte wenden Sie sich an den Absender.',
  home_request_notexists:
    'Diese Dokumentenanfrage existiert nicht. Bitte wenden Sie sich an den Absender.',
  home_qrcode_title: 'QR-Code einfach mit dem Handy scannen',
  home_pin_required: 'Eingabe von Sicherheitscode erforderlich',
  home_deadline_title: 'Frist: %s',
  home_security_info: 'Nur <b>%s</b> %s die Dateien sehen.',
  home_security_info_part_may: 'kann',
  home_security_info_part_will: 'wird',

  home_cookies_main:
    'Um unsere Webseite für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies. Durch die weitere Nutzung der Webseite stimmen Sie der Verwendung von Cookies zu. Weitere Informationen zu Cookies erhalten Sie in unserer Datenschutzerklärung.',
  home_cookie_accept: 'Akzeptieren',
  home_cookie_necessary: 'Notwendig',
  home_cookie_change: 'Anpassen',
  home_cookie_statistic: 'Nutzungsstatistiken',

  qr_direkt_request_or: 'oder',
  qr_direkt_request_message: 'geben Sie Anfrage-URL direkt an',
  qr_start_what_next: 'Wie wollen Sie fortfahren?',
  qr_start_scan_btn: 'Scan starten',
  qr_start_request_btn: 'Neu Anfrage Starten',
  qr_paste_url_placeholder: 'Anfrage-URL einfügen',
  qr_start_save_template: 'Vorlage speichern',
  qr_start_start_template: 'Starten',
  qr_start_ignore_template: 'Ignorieren und nicht mehr fragen',
  qr_start_delete_template: '%s Vorlage löschen?',
  qr_start_delete_one_template: 'Vorlage löschen',
  qr_start_template_not_found:
    'Diese Vorlage wurde nicht gefunden und kann nicht gestartet werden. Sie können sie aus der Liste löschen oder behalten und es später erneut versuchen.',
  qr_start_template_later: 'Später',
  offline_template_unavailable:
    'Diese Vorlage ist offline nicht verfügbar. Bitte verbinden Sie sich mit dem Internet und öffnen Sie die Vorlage einmal, um sie für die Offline-Nutzung zu speichern.',
  offline_template_submit:
    'Zum Absenden dieser Anfrage ist eine Internetverbindung erforderlich. Bitte gehen Sie online und versuchen Sie es erneut.',
  pwa_update_title: 'Update verfügbar',
  pwa_update_applying: 'App wird aktualisiert…',
  pwa_update_message:
    'Eine neue Version der App ist verfügbar. Jetzt aktualisieren? Nicht gespeicherte Änderungen gehen verloren.',
  pwa_update_now: 'Aktualisieren',
  pwa_update_later: 'Später',
  pwa_install_prompt_message:
    'Möchten Sie die Paperfly App von Ihrem Homescreen nutzen?',
  pwa_install_prompt_link: 'Siehe Installationsanleitung',
  pwa_install_guide_popup_title: 'Paperfly App installieren',
  pwa_install_guide_intro: 'Installieren Sie die App auf Ihrem Homescreen.',
  pwa_install_guide_ios_title: 'Installieren auf iPhone oder iPad',
  pwa_install_guide_ios_step_1: 'Öffnen Sie diese Seite in Safari.',
  pwa_install_guide_ios_step_2: 'Tippen Sie auf die Teilen-Schaltfläche.',
  pwa_install_guide_ios_step_3:
    'Wählen Sie „Zum Home-Bildschirm“ hinzufügen und bestätigen.',
  pwa_install_guide_android_title: 'Installieren auf Android',
  pwa_install_guide_android_step_1: 'Öffnen Sie das Browser-Menü.',
  pwa_install_guide_android_step_2: 'Tippen Sie auf „App installieren“.',
  pwa_install_guide_android_step_3: 'Bestätigen Sie die Installation.',
  pwa_install_guide_samsung_step_1: 'Öffnen Sie das Browser-Menü.',
  pwa_install_guide_samsung_step_2:
    'Tippen Sie auf „Zu Startseite hinzufügen“.',
  pwa_install_guide_samsung_step_3: 'Wählen Sie „Startseite“ und bestätigen.',
  pwa_install_guide_firefox_android_step_1: 'Öffnen Sie das Browser-Menü.',
  pwa_install_guide_firefox_android_step_2:
    'Tippen Sie auf „Installieren“ oder „Zum Startbildschirm“.',
  pwa_install_guide_firefox_android_step_3: 'Bestätigen Sie die Installation.',
  pwa_install_guide_default_title: 'In Ihrem Browser installieren',
  pwa_install_guide_default_step_1: 'Öffnen Sie das Browser-Menü.',
  pwa_install_guide_default_step_2:
    'Suchen Sie nach „Install app“ / „Add to Home“. ',
  pwa_install_guide_default_step_3: 'Bestätigen und den Hinweisen folgen.',
  qr_start_scan: 'Bitte scannen Sie den Paperfly QR-Code.',
  qr_start_message:
    'Um den QR-Code zu scannen ist es notwendig, die Kamera zur Nutzung in Ihrem Browser freizugeben.',

  list_done: 'Fertigstellen',
  list_send_docs: 'Dokumente senden',
  list_request_processing: 'In bearbeitung',
  list_title_documents: 'Dokumente:',
  list_title_scan_documents: 'Bitte folgende Dokumente einreichen:',
  list_title_got_documents: 'Sie haben folgende Dokumente erhalten:',
  list_expired_warning_text:
    'Die Frist für die Einreichung der Dokumente ist abgelaufen. Bitte wenden Sie sich an den Absender.',
  list_success_message:
    'Die Dokumente wurden am %s Uhr erfolgreich übermittelt.',
  document_success_message:
    'Das Dokument wurde am %s Uhr erfolgreich übermittelt.',
  list_success_message_at: ' um',
  list_item_scanned_document: 'Gescannte Dokument',
  list_item_scann_next: 'Weiter scannen',
  list_item_original_document: 'Original Dokument',
  list_load_saved_documents:
    '<p>Für diese Anfrage liegen Daten vor, die zwischengespeichert wurden.</p>Wollen Sie den Zwischenstand wiederherstellen?',
  list_load_saved_documents_yes: 'Ja - die Bearbeitung fortsetzen',
  list_load_saved_documents_no: 'Nein - neu anfangen',

  standalone_draft_notification_title: 'Vorgang Fortsetzen',
  standalone_draft_notification_text:
    'Es liegen gespeicherte Daten für die Vorlage "%s" vor.',
  standalone_draft_restore:
    '<p>Es liegen zwischengespeicherte Daten für die Vorlage "%s" vor.</p>Möchten Sie die Bearbeitung fortsetzen?',
  standalone_draft_discard_other:
    'Es liegen gespeicherte Daten für die Vorlage "%s" vor. Wenn Sie eine neue Vorlage starten, gehen die zuvor gespeicherten Daten verloren.',
  standalone_draft_continue: 'Fortsetzen',
  standalone_draft_saved_at: 'Zuletzt gespeichert: %s',
  standalone_draft_new_start: 'Neu starten',
  standalone_draft_restart: 'Vorgang neu starten',

  idcheck_summary: 'ID-Prüfung - Zusammenfassung',
  idcheck_take_photo: 'Bild aufnehmen',
  idcheck_start_camera: 'Kamera starten',
  idcheck_page_selfie_step_title: 'Selfie',
  idcheck_page_title_selfie: 'Ihr Foto',
  idcheck_page_title_pass: 'Ausweis',
  idcheck_scan_pass_item_title: 'Ausweis scannen',
  idcheck_scan_pass_item_message_part1: 'Bitte scannen Sie Ihren ',
  idcheck_scan_pass_item_message_part2: ' oder ',
  idcheck_idcard: 'Personalausweis',
  idcheck_pass: 'Reisepass',
  idcheck_doselfie_item_title: 'Ihr Foto',
  idcheck_doselfie_item_message:
    'Fast fertig, machen Sie jetzt bitte noch ein Selfie von sich.',
  idchek_document_front_side_step_title: 'Vorderseite',
  idchek_document_front_side_title: 'Vorderseite',
  idchek_document_front_side_desc_passport:
    'Bitte laden Sie ein Foto Ihres Reisepasses hoch.',
  idchek_document_front_side_desc_identificationCard:
    'Bitte laden Sie ein Foto der Vorderseite Ihres Personalausweises hoch.',
  idchek_document_front_side_desc_driversLicense:
    'Bitte laden Sie ein Foto der Vorderseite Ihres Führerscheins hoch.',
  idchek_document_doc_photo_step_title: 'Reisepass',
  idchek_document_doc_photo_title: ' Reisepass',
  idchek_document_doc_photo_desc:
    'Bitte laden Sie ein Foto Ihres Reisepasses hoch.',
  idchek_document_back_side_step_title: 'Rückseite',
  idchek_document_back_side_title: 'Rückseite',
  idchek_document_back_side_desc_identificationCard:
    'Bitte laden Sie ein Foto der Rückseite Ihres Personalausweises hoch.',
  idchek_document_back_side_desc_driversLicense:
    'Bitte laden Sie ein Foto der Rückseite Ihres Führerscheins hoch.',
  idchek_document_live_photo_step_title: 'Live-Foto',
  idchek_document_live_photo_title: 'Live-Foto',
  idchek_document_live_photo_desc:
    'Bitte halten Sie Ihren %s vor Ihre Kamera, damit die Reflexion der Dokumentenhologramme sichtbar ist.',
  idchek_document_select_doc_type_step_title: 'Document type',
  idchek_document_select_doc_type_title:
    'Welches Dokument möchten Sie verwenden?',
  idchek_document_select_doc_type_desc:
    'Welches Dokument möchten Sie verwenden?',
  continue_on_mobile: 'Auf Smartphone wechseln',
  continue_on_mobile_title: 'Auf Smartphone wechseln',
  idchek_do_on_desktop: 'Auf diesem Computer fortfahren',
  continue_on_mobile_continue: 'Auf Smartphone fortsetzen',
  continue_on_mobile_or_desktop: 'Wie möchten Sie mit fortfahren?',
  continue_on_mobile_after_done:
    'Nachdem Sie auf Ihrem Smartphone fertig sind, klicken Sie auf WEITER, um fortzufahren.',
  id_check_doc_type_identificationCard: 'Personalausweis',
  id_check_doc_type_passport: 'Reisepass',
  id_check_doc_type_driversLicense: 'Führerschein',

  idcheck_hold_phone_camera_information:
    'Bitte halten Sie Dokument vor Ihre Kamera, damit die Reflexion der Dokumentenhologramme sichtbar ist.',
  idcheck_hold_web_camera_information:
    'Pleas hold on Your document in front of the Your computer Web Camera, so that reflection of document hologram can be visible (like an example photo).',
  idcheck_load_photo_information:
    'Bitte laden Sie ein Foto der Vorderseite Ihres Personalausweises hoch.',

  cropper_is_to_small_message:
    'Das Bild ist zu klein. Bitte versuchen Sie es noch einmal.',
  cropper_repeat: 'Wiederholen',
  cropper_crop_on: 'Zuschnitt an',
  cropper_crop_off: 'Zuschnitt aus',
  cropper_next: 'Weiter',

  action_rotate: 'Drehen',
  action_replace: 'Ersetzen',

  forms_fill_next: 'Weiter ausfüllen',
  forms_fill_later: 'Später ausfüllen',
  forms_cancel_changes: 'Änderungen verwerfen',
  forms_required: 'Dieses Feld ist erforderlich',
  forms_wrong_digit: 'Bitte nur Zahlen eingeben',
  forms_wrong_email: 'Bitte richtigen E-Mail eingeben',
  forms_wrong_email_phone:
    'Bitte eine gültige E-Mailadresse oder Mobilfunknummer eingeben',
  forms_wrong_phone: 'Bitte eine gültige Mobilfunknummer eingeben',
  forms_external_validation_error:
    'Bei der Formularvalidierung ist ein Fehler aufgetreten. Sie können das Formular nicht abschließen. Bitte wenden Sie sich an den Absender oder versuchen Sie es später erneut.',
  forms_external_validation_wait:
    'Bitte warten — Ihre Formulareingaben werden vom Absender validiert.',
  forms_external_validate: 'Prüfen',
  forms_wrong_value: 'Bitte richtige wert eingeben',
  forms_return_to_pdf: 'Zurück zu PDF Ansicht',
  forms_pdf_as_quickform: 'Quick Formular Ansicht',

  confirm_bio_data_collecting_title: 'Zustimmung',
  confirm_bio_data_collecting_message:
    'Im Rahmen der elektronischen Unterschrift werden Ihre Schreibgeschwindigkeit, Schreibrichtung, Schreibpausen und gegebenenfalls der Schreibdruck (Daten besonderer Kategorien) erfasst und verschlüsselt gespeichert. Dies dient dem Nachweis, dass Sie die Unterschrift geschrieben haben. Wenn Sie der Verarbeitung dieser Daten nicht zustimmen, haben Sie die Möglichkeit, auf Papier zu unterschreiben. Sie haben das Recht, Ihre Einwilligung jederzeit zu widerrufen. Der Widerruf der Einwilligung hat keine Auswirkungen auf die Rechtmäßigkeit der aufgrund Ihrer Einwilligung bis zum Widerruf durchgeführten Verarbeitung.',
  confirm_bio_data_collecting_confirm: 'Zustimmen',

  user_credentials_title: 'Notwendige Daten',

  documents_confirmed: 'Bestätigt',

  complete_page_perform: 'Fortsetzen',
  complete_page_title: 'Bestätigung erforderlich',
  complete_page_message:
    'Ihre bisher eingegebenen Daten werden an %s übermittelt. Bitte beachten Sie, dass bereits übermittelte Daten anschließend nicht mehr bearbeitet werden können.',

  filter_document: 'Dokument',
  filter_photo: 'Foto',
  filter_bwmode: 'Graustufen',

  pdf_prev_page: 'Seite zurück',
  pdf_next_page: 'Nächste Seite',
  pdf_form_hide_smartfill: 'Eingabehilfe ausblenden',
  pdf_form_show_smartfill: 'Eingabehilfe starten',
  pdf_smartfill_step: 'Schritt:',
  pdf_return_from_smartfill:
    'Wir haben Ihre Eingaben in das Dokument eingetragen. Bitte überprüfen Sie das Dokument.',

  dialog_send_now: 'Dokumente jetzt übermitteln?',
  dialog_delete_all: 'Alle Seiten löschen?',
  dialog_delete_page: 'Selektierte Seite löschen?',
  dialog_delete_page_x: 'Seite %s löschen?',
  dialog_delete_pages: 'Selektierte Seiten löschen?',
  dialog_load_all_required: 'Bitte alle Pflichtdokumente anhängen.',
  dialog_attention: 'Achtung',
  dialog_warning: 'Warnung',
  dialog_processing: 'in Bearbeitung...',
  dialog_fill_all_fields: 'Bitte alle Felder ausfüllen.',
  dialog_sending: 'Übermitteln...',
  dialog_error_on_send:
    'Beim Hochladen von Dokumenten ist ein Fehler aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.<br/><br/><div style="text-align: left; max-height: 70vh; overflow: auto;padding-left: 10px; font-size: 11px; color: #999">%s</div>',
  dialog_error_on_send_invalid_image:
    'Mindestens ein hochgeladenes Bild ist beschädigt oder liegt in einem nicht unterstützten Format vor. Bitte kehren Sie zu dem/den aufgeführten Dokument(en) zurück, laden Sie das Bild erneut hoch bzw. fotografieren Sie es erneut und senden Sie die Anfrage danach erneut ab.<br/><br/><div style="text-align: left; max-height: 70vh; overflow: auto;padding-left: 10px; font-size: 11px; color: #999">%s</div>',
  sender_invalid_image_hint:
    'Bild ist beschädigt oder nicht unterstützt. Bitte erneut hochladen oder fotografieren.',
  dialog_fill_all_required: 'Bitte alle Pflichtfelder ausfüllen.',
  dialog_changies_will_removed:
    'Alle Änderungen werden gelöscht. \nWollen Sie wirklich fortfahren?',
  dialog_continue: 'Fortfahren',
  dialog_required_document_IMMEDIATE_CONFIRMATION:
    'Bitte bestätigen Sie das Dokument "%s".',
  dialog_required_document_ID_CHECK: 'Bitte führen Sie die ID-Prüfung aus.',
  dialog_required_document_FORM: 'Bitte füllen Sie das Dokument "%s" aus.',
  dialog_required_document_FORM_PDF: 'Bitte füllen Sie das Dokument "%s" aus.',
  dialog_required_document_DOCUMENT:
    'Bitte das Dokument "%s" hochladen / fotografieren.',
  dialog_required_document_PAYMENT: 'Bitte führen Sie die Zahlung aus.',
  dialog_required_document_INFORMATION: 'Bitte lesen Sie das Dokument "%s".',
  footer_imprint: 'Impressum',
  footer_conditions: 'AGB',
  footer_privacy: 'Datenschutz',
  footer_support: 'Support',

  thankyou_is_done: "Vielen Dank, das war's schon!",
  thankyou_receive_your_documents: '%s hat jetzt Ihre Unterlagen erhalten.',
  thankyou_you_may_close: 'Sie können jetzt diese Seite schließen.',

  info_popup_docs_from:
    'Sie haben diese Dokumentenanfrage von <b>%s</b> erhalten. ',
  info_popup_message_part1: 'Dieser Service wird von ',
  info_popup_message_part2:
    ' ermöglicht. Mit Paperfly können Dokumente, Daten, Signaturen, Legitimationen und Zahlungen angefordert werden. Wenn Sie mehr über Paperfly erfahren möchten, schauen Sie sich dieses kurze ',
  info_popup_message_part3: ' an.',
  info_popup_emailto_sender_1: 'Sie können %s über ',
  info_popup_emailto_sender_2: ' kontaktieren.',

  upload_load_next_page: 'Bitte laden sie weitere %s seiten hoch',
  upload_all_done: 'Alle Seiten sind fertig',
  upload_delete_page: 'Seite löschen',
  upload_camera: 'Fotografieren',
  upload_disk: 'Hochladen',
  upload_file: 'Datei auswählen',

  sort_next_x_pages: 'Weitere %s Seiten',
  sort_new_page: 'Neue Seite',
  sort_next_x_pages_photo: 'Weitere %s Fotos',
  sort_new_page_photo: 'Neues Foto',
  sort_prepare_page_x: 'Bitte Seite %s vorbereiten',
  gallery_select_pages: 'Seiten auswählen',
  gallery_x_from_y_selected: '%s von %s ausgewählt',

  payment_creditcard: 'Kreditkarte',
  payment_sepa: 'Sepa',
  payment_wallet: 'Wallet',
  payment_error_message:
    'Bei der ausführung der zahlung ist ein fehler aufgetreten',
  payment_error_title: 'Zahlung fehlgeschlagen',
  payment_do_pay: 'Zahlen',
  payment_pay: 'Bezahlen',
  payment_sepa_information:
    'Sie haben dem Lastschriftmandat zugestimmt. Der Betrag in der Höhe von %s wird von Ihrem Bankkonto abgebucht.',
  payment_paid: 'Bezahlt',
  payment_summ: 'Betrag',
  payment_change_payment_method: 'Zahlungsmethode ändern',
  payment_select_payment_method: 'Bitte wählen Sie eine Zahlungsmethode',
  payment_pay_x: '%s bezahlen',
  payment_iban: 'IBAN',
  payment_sepa_long_information:
    'Indem Sie dem SEPA-Lastschriftmandat zustimmen, autorisieren Sie Paperfly und Stripe, Zahlungen von Ihrem Bankkonto mittels Lastschrift einzuziehen. Zugleich weisen Sie Ihr Kreditinstitut an, die von Paperfly und Stripe gezogenen Lastschriften einzulösen. Hinweis: Sie können innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit Ihrem Kreditinstitut vereinbarten Bedingungen.',
  payment_confirm_sepa: 'Lastschriftmandat bestätigen',
  payment_wallet_not_available: 'Zur Zeit leider nicht verfügbar',

  viewer_download_required_title: 'Dokument herunterladen',
  viewer_download_required_message:
    'Bitte laden Sie das Dokument herunter und speichern oder drucken Sie es, bevor Sie fortfahren.',

  forms_sign: 'Unterschreiben',
  forms_sign_with_yes: 'Mit yes® signieren',
  forms_sign_with_atrust: 'Mit Atrust signieren',
  forms_sign_please: 'Bitte unterschreiben',

  camera_disabled_title: 'Paperfly möchte auf die Kamera zugreifen',
  camera_disabled_message:
    'Der Kamerazugriff wurde blockiert. Ohne diese Berechtigung kann die Kamera nicht verwendet werden.',
  camera_disabled_help_chrome:
    'So geben Sie die Kamera wieder frei: Klicken Sie auf das Schloss- oder Kamerasymbol links in der Adressleiste → Kamerazugriff auf „Zulassen“ stellen → Seite neu laden und erneut versuchen.',
  camera_disabled_help_safari_ios:
    'So geben Sie die Kamera wieder frei: Tippen Sie in Safari auf „aA“ links in der Adressleiste → „Website-Einstellungen“ → Kamera auf „Erlauben“ → zurück zur App und erneut versuchen.',
  camera_disabled_help_safari:
    'So geben Sie die Kamera wieder frei: Safari-Menü → Einstellungen für diese Website → Kamera auf „Erlauben“ → Seite neu laden und erneut versuchen.',
  camera_disabled_help_firefox:
    'So geben Sie die Kamera wieder frei: Klicken Sie auf das Berechtigungssymbol links in der Adressleiste → Kamera erlauben → Seite neu laden und erneut versuchen.',
  camera_disabled_help_generic:
    'Öffnen Sie die Website-Einstellungen Ihres Browsers, erlauben Sie den Kamerazugriff für diese Seite und versuchen Sie es erneut.',
  camera_permission_preprompt:
    'Im nächsten Schritt fragt Ihr Browser nach dem Kamerazugriff. Bitte wählen Sie „Zulassen“.',
  camera_permission_continue: 'Kamera starten',
  camera_permission_retry: 'Erneut versuchen',
  camera_starting_message: 'Kamera wird gestartet…',
  camera_error_message: 'Es wurde keine Kamera gefunden',
  camera_error_message2: 'Kamera funktioniert nicht',

  common_error: 'Fehler',
  common_page: 'Seite ',
  common_page_x: 'Seite %s',
  common_all: 'Alle',
  common_page_x_from_y: 'Seite %s / %s',
  common_page_x_from_y_2: 'Seite %s von %s',
  common_yes: 'Ja',
  common_name: 'Name',
  common_email: 'Email',
  common_count_selected: '%s ausgewählt',

  sender_cant_send_request: 'Die Aktion kann nicht abgeschlossen werden',
  //qes
  dialog_edit_will_off_after_qes_title: 'Alle Felder ausgefüllt?',
  dialog_edit_will_off_after_qes:
    'Stellen Sie sicher, dass Sie alle relevanten Felder ausgefüllt haben. Sobald das Dokument signiert wurde, können keine weiteren Änderungen vorgenommen werden.',

  //signme
  signme_now_document_sign: 'Dokument Qualifiziert unterschreiben',
  signme_settings_registration_info:
    '<b>sign-me</b> ist ein Service von D-Trust GmbH. Wir arbeiten mit D-Trust zusammen, um Ihnen <b>Qualifizierte Signaturen</b> anbieten zu können.',
  dialog_signme_settings_title: 'sign-me einrichten',
  dialog_signme_preparing_title: 'Vorbereitung',
  dialog_signme_preparing_help:
    'Bitte warten Sie, während wir das Dokument für die sign-me-Registrierung vorbereiten.',
  dialog_signme_preparing_help_login:
    'Bitte warten Sie, während wir das Dokument für die Signatur vorbereiten.',
  dialog_signme_ready_to_register_help:
    'Drücken Sie «Einrichten», um die Registrierung im sign-me-Fenster fortzusetzen.',
  dialog_signme_ready_to_sign_help:
    'Drücken Sie START, um die Signatur im sign-me-Fenster abzuschließen.',
  dialog_signme_registration_done_sign_hint:
    'Registrierung erfolgreich abgeschlossen. Drücken Sie START, um mit Ihrem erstellten Konto zu unterschreiben.',
  dialog_signme_awaiting_register_help:
    'Bitte schließen Sie die Registrierung im sign-me-Fenster ab.',
  dialog_signme_awaiting_sign_help:
    'Bitte schließen Sie die Signatur im sign-me-Fenster ab.',
  dialog_signme_restart_signing: 'Signatur erneut starten',
  dialog_signme_status_check_hint:
    'Die Statusprüfung kann etwa 5 Sekunden dauern. Falls das sign-me-Fenster aus einem anderen Grund geschlossen wurde, starten Sie die Signatur erneut.',
  dialog_signme_status_check_help: 'Signaturstatus wird geprüft…',
  dialog_signme_confirm_restart_signing:
    'Prüfung des Signaturstatus abbrechen und Signatur erneut starten?',
  dialog_signme_confirm_abort_status_check:
    'Prüfung des Signaturstatus abbrechen?',
  signme_settings_registration_form_title: 'Ihre Daten laut Ausweis',
  signme_settings_label_mobilePhoneNumber: 'Mobilfunknummer',
  INVALID_PHONE_NUMBER_SIGNME: 'Ungültige Mobilfunknummer.',
  signme_settings_label_mobilePhoneNumber_info:
    'Trennung der Vorwahl von der restlichen Mobilfunknummer durch ein Leerzeichen erforderlich',
  signme_settings_label_emailAddress: 'Email',
  signme_settings_label_givenNames: 'Vorname',
  signme_settings_label_familyName: 'Nachname',
  signme_settings_processing_data: 'in Bearbeitung',
  esign_sign_type_not_supported:
    'Qualifizierte Signatur von "%s" nicht unterstützt',
  signme_settings_registration_done: 'sign-me erfolgreich eingerichtet',
  signme_settings_registration_failed:
    'Problem beim Einrichten von sign-me. Bitte versuchen Sie es später erneut.',
  signme_settings_nopopup_message:
    'Um sign-me nutzen zu können, erlauben Sie bitte Pop-ups in den Einstellungen Ihres Browsers.',
  yes_settings_nopopup_message:
    'Um yes® nutzen zu können, müssen Sie Pop-ups für Paperfly erlauben.',
  atrust_settings_nopopup_message:
    'Um Atrust nutzen zu können, erlauben Sie bitte Pop-ups in den Einstellungen Ihres Browsers.',
  signme_settings_nopopup_title: 'Überprüfen Sie die Browsereinstellungen',
  popup_blocked_help_chrome:
    '<b>Pop-ups in Google Chrome zulassen</b><br/><br/><b>Empfohlen (ohne Neuladen):</b><br/>• Schauen Sie in die Adressleiste – dort erscheint oft ein Symbol für blockierte Pop-ups (durchgestrichenes Fenster).<br/>• Klicken Sie darauf und erlauben Sie Pop-ups für diese Website.<br/>• Tippen Sie danach erneut auf Start – die Seite nicht neu laden, sonst gehen eingegebene Daten verloren.<br/><br/><b>Falls kein Symbol sichtbar ist:</b><br/>• Klicken Sie oben rechts auf das Dreipunkt-Menü → Einstellungen.<br/>• Datenschutz und Sicherheit → Website-Einstellungen → Pop-ups und Weiterleitungen.<br/>• Erlauben Sie Pop-ups für diese Website (benutzerdefinierte Ausnahme).<br/>• Kehren Sie zu Paperfly zurück und tippen Sie erneut auf Start – nur im Notfall die Seite neu laden.',
  popup_blocked_help_edge:
    '<b>Pop-ups in Microsoft Edge zulassen</b><br/><br/><b>Empfohlen (ohne Neuladen):</b><br/>• Schauen Sie in die Adressleiste – dort erscheint oft ein Symbol für blockierte Pop-ups (durchgestrichenes Fenster).<br/>• Klicken Sie darauf und erlauben Sie Pop-ups für diese Website.<br/>• Tippen Sie danach erneut auf Start – die Seite nicht neu laden, sonst gehen eingegebene Daten verloren.<br/><br/><b>Falls kein Symbol sichtbar ist:</b><br/>• Klicken Sie oben rechts auf das Dreipunkt-Menü → Einstellungen.<br/>• Cookies und Websiteberechtigungen → Popups und Weiterleitungen.<br/>• Erlauben Sie Pop-ups für diese Website.<br/>• Kehren Sie zu Paperfly zurück und tippen Sie erneut auf Start – nur im Notfall die Seite neu laden.',
  popup_blocked_help_safari_ios:
    '<b>Pop-ups in Safari auf dem iPhone oder iPad zulassen</b><br/><br/><b>Empfohlen (ohne Neuladen):</b><br/>• Prüfen Sie die Adressleiste oder den Hinweis „Pop-up blockiert“ und erlauben Sie das Pop-up, falls angeboten.<br/>• Tippen Sie danach erneut auf Start – die Seite nicht neu laden, sonst gehen eingegebene Daten verloren.<br/><br/><b>Falls das nicht möglich ist:</b><br/>• Öffnen Sie die App Einstellungen → Safari.<br/>• Deaktivieren Sie „Pop-ups blockieren“.<br/>• Kehren Sie zu Paperfly zurück und tippen Sie erneut auf Start – nur im Notfall die Seite neu laden.',
  popup_blocked_help_safari:
    '<b>Pop-ups in Safari zulassen</b><br/><br/><b>Empfohlen (ohne Neuladen):</b><br/>• Schauen Sie in die Adressleiste – dort erscheint oft ein Hinweis oder Symbol für blockierte Pop-ups.<br/>• Erlauben Sie Pop-ups für diese Website.<br/>• Tippen Sie danach erneut auf Start – die Seite nicht neu laden, sonst gehen eingegebene Daten verloren.<br/><br/><b>Falls kein Hinweis sichtbar ist:</b><br/>• Safari-Menü → Einstellungen (oder Einstellungen…) → Websites → Pop-up-Fenster.<br/>• Stellen Sie für diese Website „Zulassen“ ein.<br/>• Kehren Sie zu Paperfly zurück und tippen Sie erneut auf Start – nur im Notfall die Seite neu laden.',
  popup_blocked_help_firefox:
    '<b>Pop-ups in Mozilla Firefox zulassen</b><br/><br/><b>Empfohlen (ohne Neuladen):</b><br/>• Schauen Sie in die Adressleiste oder die Infoleiste – dort erscheint oft ein Hinweis auf blockierte Pop-ups.<br/>• Klicken Sie darauf und erlauben Sie Pop-ups für diese Website.<br/>• Tippen Sie danach erneut auf Start – die Seite nicht neu laden, sonst gehen eingegebene Daten verloren.<br/><br/><b>Falls kein Hinweis sichtbar ist:</b><br/>• Menü → Einstellungen → Datenschutz & Sicherheit → Berechtigungen.<br/>• Bei „Pop-up-Fenster blockieren“ → Ausnahmen… und erlauben Sie diese Website.<br/>• Kehren Sie zu Paperfly zurück und tippen Sie erneut auf Start – nur im Notfall die Seite neu laden.',
  popup_blocked_help_generic:
    '<b>Pop-ups in Ihrem Browser zulassen</b><br/><br/><b>Empfohlen (ohne Neuladen):</b><br/>• Schauen Sie in die Adressleiste – dort erscheint oft ein Symbol für blockierte Pop-ups (durchgestrichenes Fenster).<br/>• Klicken Sie darauf und erlauben Sie Pop-ups für diese Website.<br/>• Tippen Sie danach erneut auf Start – die Seite nicht neu laden, sonst gehen eingegebene Daten verloren.<br/><br/><b>Falls kein Symbol sichtbar ist:</b><br/>• Öffnen Sie die Browser-Einstellungen und suchen Sie nach Pop-ups.<br/>• Erlauben Sie Pop-ups für diese Website.<br/>• Kehren Sie zu Paperfly zurück und tippen Sie erneut auf Start – nur im Notfall die Seite neu laden.',
  signme_settings_label_name: 'Nutzer',

  signme_settings_label_status: 'Status',
  signme_settings_label_created: 'Erstellt am',
  signme_settings_label_dateOfBirth: 'Geburtsdatum',
  signme_settings_label_placeOfBirth: 'Geburtsort',
  signme_settings_label_placeOfResidence_street: 'Straße',
  signme_settings_label_placeOfResidence_city: 'Ort',
  signme_settings_label_placeOfResidence_zipCode: 'PLZ',
  signme_settings_label_placeOfResidence_country: 'Land',

  esignature_sign_document_error_message: 'Signieren von PDF fehlgeschlagen',
  esignature_sign_document_error_title: 'Signaturerstellungsfehler',
  esignature_document_signed: 'Dokument erfolgreich signiert',

  error_field_is_required: 'Dieses Feld ist erforderlich',
  INVALID_EMAIL: 'Ungültige E-Mail-Adresse',
  signme_settings_label_register: 'Einrichten',

  request_stepper_check_and_send:
    'Bitte überprüfen Sie Ihre Eingaben vor dem Senden. ',

  title_add: 'Hinzufügen',
  title_attention: 'Hinweis',
  title_show_more: 'Mehr anzeigen',
  title_edit: 'Bearbeiten',
  title_check: 'Fertig',
  title_yes: 'Ja',
  title_ok: 'Ok',
  title_sendout: 'Abschicken',
  title_no: 'Nein',
  title_will_prepared: ' wird verarbeitet...',
  title_preparing: 'Vorbereitung',
  title_load: 'Laden',
  title_fill: 'Ausfüllen',
  title_change: 'Ändern',
  title_execute: 'Ausführen',
  title_read: 'Lesen',
  title_read_and_accept: 'Lesen & Bestätigen',
  title_had_read: 'Zur letzten Seite',
  title_see: 'Ansehen',
  title_do_select: 'Wählen',
  title_confirmation: 'Bestätigung',
  title_confirm: 'Bestätigen',
  title_unconfirm: 'Bestätigung zurücknehmen',
  title_unconfirm_short: 'Widerruf',
  title_delete: 'Löschen',
  title_successfull: 'Erfolgreich',
  title_successfull_sent: 'Erfolgreich übermittelt',
  title_cancel: 'Abbrechen',
  title_select: 'Auswählen',
  title_dropdown_select: 'Auswählen...',
  title_done: 'Fertig',
  title_summary: 'Zusammenfassung',
  title_close: 'Schließen',
  title_reject: 'Ablehnen',
  title_reject_and_send: 'Ablehnen und Abschließen',
  title_information: 'Information',
  title_or: 'oder',
  title_back: 'Zurück',
  title_prev: 'Zurück',
  title_next: 'Weiter',
  title_continue: 'Weiter',
  title_start: 'Start',
  title_fillin: 'Ausfüllen',
  title_read_next: 'Weiter lesen',
  title_save: 'Speichern',
  title_personal_message: 'Nachricht des Absenders:',
  title_documents_request: 'Dokumentenanfrage',
  title_loading: 'Wird geladen',
  title_print: 'Drucken',
  title_download: 'Herunterladen',
  title_print_and_sign: 'Drucken und unterschreiben',
  title_camera: 'Kamera',
  title_upload_signature: 'Unterschrift hochladen',
  title_sign_on_mobile: 'Auf Handy unterschreiben',
  title_sign_on_screen: 'Auf Bildschirm unterschreiben',
  title_use_last_signature: 'Letzte unterschrift verwenden',
  title_please_choose: 'Bitte wählen',
  title_done_request: 'Anfrage abschließen?',
  title_done_request_rest_signatures:
    'Folgende Unterschriftsfelder sind noch offen:',
  title_done_request_confirm: 'Wollen Sie diese Anfrage wirklich abschließen?',
  title_done_request_with_sign_confirm:
    ' Es sind noch weitere Unterschriftsfelder vorhanden. Wollen Sie diese Anfrage wirklich abschließen?',
  title_step: 'Schritt',
  title_apply: 'Anwenden',
  title_today: 'Heute',

  sign_on_mobile_info: 'Scannen Sie diesen QR-Code mit Ihrem Handy',
  sign_on_mobile_set_failed:
    'Problem beim senden von Signature. Bitte versuchen Sie es später erneut.',

  post_request_save_email_message:
    'Möchten Sie eine Kopie der Daten per E-Mail oder SMS erhalten?',
  post_request_save_email_only_message:
    'Möchten Sie eine Kopie der Daten per E-Mail erhalten?',
  post_request_save_email_success:
    'Sie erhalten in Kürze eine %s mit einem Download-Link.',
  post_request_your_email: 'Ihre E-Mail',
  post_request_your_email_message: 'Ihre E-Mail-Adresse oder Mobilfunknummer',
  post_request_your_email_only_message: 'Ihre E-Mail-Adresse',
  post_request_your_phone_only_message: 'Ihre Mobilfunknummer',
  post_request_wrong_email_phone:
    'Bitte eine gültige E-Mailadresse oder Mobilfunknummer eingeben',
  post_request_wrong_email_only: 'Bitte eine gültige E-Mailadresse eingeben',
  post_request_wrong_phone_only: 'Bitte eine gültige Mobilfunknummer eingeben',
  post_request_email: 'E-Mail',
  post_request_sms: 'SMS',

  create_case_message_1: 'Fast fertig!',
  create_case_message_2:
    'Bitte geben Sie Ihren Namen und Ihre E-Mail-Adresse oder Mobilfunknummer ein.',
  create_case_your_data: 'Ihre Daten:',
  create_case_recipient: 'Empfänger %s ',
  create_case_recipient_data: '%s Daten:',
  create_case_your_name: 'Ihr Name',
  create_case_your_firstName: 'Ihr Vorname',
  create_case_your_lastName: 'Ihr Nachname',
  create_case_recipient_name: 'Empfänger %s Name',
  create_case_name: 'Name',
  create_case_role_name: '%s Name',
  create_case_role_email: '%s E-Mail',
  create_case_role_phone: '%s Mobilfunknummer',
  create_case_role_email_phone: '%s E-Mail oder Mobilfunknummer',
  create_case_email_phone: 'E-Mail oder Mobilfunknummer',
  create_case_your_email_phone: 'Ihre E-Mail oder Mobilfunknummer',
  create_case_phone: 'Ihre Mobilfunknummer',
  create_case_recipient_email_phone: 'Empfänger %s E-Mail oder Mobilfunknummer',
  create_case_recipient_phone: 'Empfänger %s Mobilfunknummer',
  create_case_rights_text:
    'Ich habe die <a class="link external" href="https://paperfly.io/privacy/" target="_blank">Datenschutzerklärung</a> zur Kenntnis genommen. Ich stimme einer elektronischen Speicherung und Verarbeitung meiner eingegebenen Daten zu.' +
    '<p><i>Hinweis: Die Einwilligung kann jederzeit für die Zukunft per E-Mail an %s widerrufen werden.</i></p>',

  recent_templates: 'Gespeicherte Vorlagen',
  qr_add_new_template: 'Neu Vorlage hinzufügen',
  qr_new_template: 'Neu Vorlage',

  restart_app_title: 'Anwendung aktualisieren',
  restart_app_message: 'Die Anwendung muss aktualisiert werden',
  restart_app_no: 'Abbrechen',
  restart_app_yes: 'Aktualisieren',

  merkur_message_1:
    'Dürfen wir für zukünftige Bestätigungen per Email oder SMS mit Ihnen in Kontakt treten?',
  merkur_message_2:
    'Das macht Ihre Bankgeschäfte nicht nur deutlich einfacher, sondern leistet darüber hinaus einen aktiven Beitrag zum Umwelt- und Klimaschutz. Wenn Sie damit einverstanden sind, ergänzen Sie einfach die folgenden Angaben.',
  merkur_sendout_agree: 'Ja, ich möchte per Email oder SMS kontaktiert werden.',

  dialog_aes_popup_title: 'Ihre Identität bestätigen',
  aes_popup_docs_title:
    'Folgende Dokumente werden mit einer fortgeschrittenen Signatur signiert:',
  aes_popup_sign: 'SIGNIEREN',
  aes_popup_label_agb:
    'Hiermit bestätige ich, dass mein Vor- und Nachname, die E-Mail und \n' +
    'die Mobilfunknummer korrekt sind.',
  aes_popup__info: 'Ihre Signatur wird folgende Daten beinhalten: ',
  opt_enter_code:
    'Bitte geben Sie den SMS-Code ein, den wir an Ihr Mobiltelefon gesendet haben ',
  opt_verify: 'Code überprüfen',
  aes_popup_if_data_wrong_absender: ' den Absender',
  aes_popup_label_name: 'Name',
  aes_popup_label_emailAddress: 'Email',
  aes_popup_label_phone: 'Mobilfunknummer',
  aes_popup_if_data_wrong:
    'Falls Ihre Daten falsch sind, kontaktieren Sie bitte ',
  opt_popup_error:
    'Es ist ein technischer Fehler aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut',
  opt_get_code: 'Bestätigungscode anfordern',
  opt_code_success: 'Sie haben sich erfolgreich authentifiziert',
  dialog_opt_popup_title: 'Zwei faktor authentifizierung',

  app_fatal_err:
    'Es tut uns leid, aber es ist ein interner Fehler aufgetreten.',
  app_restart_app: 'Applikation neustarten',
  app_send_err: 'Fehler melden:',
  app_err_desc: 'Beschreibung (optional)',
  app_err_send: 'Senden'
};

export default dictionary_de;
